import React, {useCallback, useMemo, useState} from 'react';
import {selectLang, Translate} from "../../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import AsyncSelect from "react-select/async";
import {debounce} from "underscore";
import roamingEmpowermentService from "../../../../../services/roaming/roamingEmpowermentService";

const RoamingInvoiceEmpowermentSelector = ({filter, onChange}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const [empowerment, setEmpowerment] = useState(null);

    const debouncedLoadCompanies = useMemo(() => {
        return debounce(async (inputValue, callback) => {
            inputValue.replace(/\W/g, '')

            try {
                const {data: empowerments} = await roamingEmpowermentService.getExecutorEmpowerments({...filter, number: inputValue});
                callback(empowerments);
            } catch (error) {
                callback([]);
            }
        }, 500);
    }, [filter]);
    const loadEmpowerments = useCallback(
        (inputValue, callback) => {
            debouncedLoadCompanies(inputValue, callback);
        },
        [debouncedLoadCompanies]
    );

    const onChangeHandler = (empowerment) => {
        setEmpowerment(empowerment);
        onChange(empowerment);
    };

    return (
        <AsyncSelect cacheOptions={true}
                     defaultOptions={false}
                     isClearable={true}
                     isSearchable={!empowerment}
                     placeholder={t(lang, 'items.common.select')}
                     getOptionValue={option => option.id}
                     getOptionLabel={option => `${option.info.number} - ${option.info.start}`}
                     loadOptions={loadEmpowerments}
                     value={empowerment}
                     onChange={onChangeHandler}
        />
    );
};

export default RoamingInvoiceEmpowermentSelector;